if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.content = this.querySelector('[role="document"]');
        this.prevButton = this.querySelector('.product-media-modal__nav--prev');
        this.nextButton = this.querySelector('.product-media-modal__nav--next');
        this.counter = this.querySelector('.product-media-modal__counter');

        [this.prevButton, this.nextButton].forEach((button) => {
          button?.addEventListener('pointerup', (event) => event.stopPropagation());
        });
        this.prevButton?.addEventListener('click', () => this.slideBy(-1));
        this.nextButton?.addEventListener('click', () => this.slideBy(1));
        this.content.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
        this.addEventListener('keydown', (event) => {
          if (event.code === 'ArrowLeft') this.slideBy(-1);
          if (event.code === 'ArrowRight') this.slideBy(1);
        });
      }

      get slides() {
        return Array.from(this.content.querySelectorAll(':scope > [data-media-id]')).filter(
          (slide) => slide.offsetWidth > 0
        );
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const openedMediaId = this.openedBy?.getAttribute('data-media-id');
        const slides = this.slides;
        const index = Math.max(
          slides.findIndex((slide) => slide.getAttribute('data-media-id') === openedMediaId),
          0
        );
        this.goTo(index, 'instant');
      }

      goTo(index, behavior = 'smooth') {
        const slides = this.slides;
        if (!slides.length) return;
        index = Math.min(Math.max(index, 0), slides.length - 1);
        this.content.scrollTo({ left: this.slideOffset(slides[index]), behavior });
        this.setActiveSlide(index);
      }

      slideBy(direction) {
        this.goTo(this.currentIndex() + direction);
      }

      slideOffset(slide) {
        return slide.offsetLeft - this.content.offsetLeft;
      }

      currentIndex() {
        const slides = this.slides;
        const scrollLeft = this.content.scrollLeft;
        let closestIndex = 0;
        let closestDistance = Infinity;
        slides.forEach((slide, index) => {
          const distance = Math.abs(this.slideOffset(slide) - scrollLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });
        return closestIndex;
      }

      onScroll() {
        clearTimeout(this.scrollTimeout);
        this.scrollTimeout = setTimeout(() => this.setActiveSlide(this.currentIndex()), 100);
      }

      setActiveSlide(index) {
        const slides = this.slides;
        slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === index;
          slide.classList.toggle('active', isActive);
          if (!isActive) {
            slide.querySelectorAll('video').forEach((video) => video.pause());
          }
        });

        const activeSlide = slides[index];
        if (
          activeSlide?.nodeName === 'DEFERRED-MEDIA' &&
          !activeSlide.getAttribute('loaded') &&
          activeSlide.querySelector('template')
        ) {
          activeSlide.loadContent(false);
        }

        if (this.counter) this.counter.textContent = `${index + 1} / ${slides.length}`;
        if (this.prevButton) this.prevButton.toggleAttribute('disabled', index === 0);
        if (this.nextButton) this.nextButton.toggleAttribute('disabled', index === slides.length - 1);
      }

    }
  );
}
